import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// @ flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import withMatch from '@/hocs/withMatch';
import styled from 'styled-components';
import { textStyles, colorPalette, shadows } from '../styles/styleGuide';
import FormGenerator from './shared/forms/FormGenerator';
import { toBreakpoint } from '../styles/breakpoints';
import { performApiRequest } from '../redux/apiData';
import { updateModalOpenState, clearModalState } from '../redux/modal';
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleClick: function handleClick(projectSlug, email) {
      dispatch(performApiRequest('requestPassword', {
        projectSlug: projectSlug
      }, {
        email: email
      }));
    },
    onClose: function onClose() {
      dispatch(updateModalOpenState(false));
      dispatch(clearModalState());
    }
  };
};
var form = [{
  options: [{
    id: 'email',
    name: 'email1',
    label: 'Vul hier je e-mailadres in',
    required: true,
    title: 'Vul hier je e-mailadres in',
    type: 'email'
  }]
}];
var ForgotPassword = /*#__PURE__*/function (_Component) {
  function ForgotPassword() {
    var _this;
    _classCallCheck(this, ForgotPassword);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ForgotPassword, [].concat(args));
    _defineProperty(_this, "state", {
      send: false
    });
    _defineProperty(_this, "handleSubmit", function (values) {
      var _this$props = _this.props,
        match = _this$props.match,
        handleClick = _this$props.handleClick;
      handleClick(String(match.params.projectSlug), values.email1);
      _this.setState({
        send: !_this.state.send
      });
    });
    _defineProperty(_this, "resetForm", function () {
      _this.setState({
        send: !_this.state.send
      });
    });
    _defineProperty(_this, "closeModal", function () {
      _this.props.onClose();
    });
    return _this;
  }
  _inherits(ForgotPassword, _Component);
  return _createClass(ForgotPassword, [{
    key: "render",
    value: function render() {
      var changePassword = this.props.changePassword;
      var send = this.state.send;
      return __jsx(Container, {
        "data-id": "components_ForgotPasswordModal_Container"
      }, !send && !changePassword && __jsx("div", {
        "data-id": "components_ForgotPasswordModal_div"
      }, __jsx(Title, {
        "data-id": "components_ForgotPasswordModal_Title"
      }, "Wachtwoord opnieuw instellen"), __jsx(SubTitle, {
        "data-id": "components_ForgotPasswordModal_SubTitle"
      }, "Wachtwoord vergeten, of wil je een nieuw wachtwoord instellen? Geen probleem, dat is binnen een handomdraai geregeld. Vul hieronder je e-mailadres in en we sturen je direct een e-mail waarmee je het wachtwoord opnieuw kunt instellen."), __jsx(FormGenerator, {
        fields: form,
        submitLabel: "Versturen",
        loadingLabel: "email wordt verzonden",
        submitFn: this.handleSubmit,
        "data-id": "components_ForgotPasswordModal_FormGenerator"
      }), __jsx(Disclaimer, {
        "data-id": "components_ForgotPasswordModal_Disclaimer"
      }, "De link in de e-mail die we je sturen is 24 uur geldig. Je kunt eens per 2 uur een nieuw wachtwoord aanvragen.")), (send || changePassword) && __jsx("div", {
        "data-id": "components_ForgotPasswordModal_div"
      }, __jsx(Title, {
        "data-id": "components_ForgotPasswordModal_Title"
      }, "We hebben je een e-mail gestuurd"), __jsx(SubTitle, {
        "data-id": "components_ForgotPasswordModal_SubTitle"
      }, "Klik op de link in de e-mail om je wachtwoord opnieuw in te stellen"), __jsx(Try, {
        "data-id": "components_ForgotPasswordModal_Try"
      }, "Geen e-mail ontvangen? Het zou kunnen dat de e-mail in de spam folder is terechtgekomen, of", ' ', __jsx("span", {
        onClick: changePassword ? this.closeModal : this.resetForm,
        "data-id": "components_ForgotPasswordModal_span"
      }, "probeer het nog een keer"))));
    }
  }]);
}(Component);
export default withMatch(connect(null, mapDispatchToProps)(ForgotPassword));
var Try = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  font-weight: normal;\n  font-style: italic;\n  margin-top: 60rem;\n\n  > span {\n    color: ", ";\n    cursor: pointer;\n  }\n"])), textStyles.subTitle, colorPalette.headerGrey, colorPalette.blue);
var SubTitle = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  font-weight: normal;\n"])), textStyles.subTitle, colorPalette.headerGrey);
var Title = styled.h2(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  margin-bottom: 20rem;\n"])), textStyles.sectionTitle, colorPalette.headerGrey);
var Container = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  padding: 80rem 200rem 142rem 200rem;\n\n  ", " ", ";\n"])), shadows.boxPrimary, toBreakpoint.lg(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    padding: 80rem 70rem 142rem 70rem;\n  "]))), toBreakpoint.md(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    padding: 80rem 20rem 142rem 20rem;\n  "]))));
var Disclaimer = styled.p(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  margin: 20rem 0 0 0;\n  ", ";\n  color: ", ";\n"])), textStyles.caption, colorPalette.textGrey);